// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CQpx","left":"styles_left__2XD14"};